import { useQuery } from '@tanstack/react-query';
import { promotionsService } from '../services/promotions.service';

export function usePromotion(id: string) {
  return useQuery({
    queryKey: ['promotions', id],
    queryFn: () => promotionsService.getPromotion(id),
    enabled: !!id,
  });
}
